import axios from 'axios';

const service = axios.create({
  // 基础路径：所有请求都会自动加上这个前缀
  // baseURL: "http://127.0.0.1:8081/", 
  baseURL: "/api", 
  // 请求超时时间（毫秒）
  timeout: 5000 
});

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    const res = response.data;
    return res;
  },
  error => {
    console.error('响应错误:', error);

    if (error.response) {
      switch (error.response.status) {
        case 401:
          console.error("Token过期或未认证")
          localStorage.removeItem('token')
          localStorage.removeItem('currentUser')
          window.location.href = "/m/login"
          break;
        case 403:
          console.error("无权限访问")
          break;
        case 404:
          console.error('请求的资源不存在');
          break;
        case 500:
          console.error('服务器内部错误');
          break;
      }
    }

    return Promise.reject(error);
  }
);

export default service;
